module.exports = __webpack_public_path__ + "0d0e017c896ed9c07feb1d86333e2d1e.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/dummy_image_duck.png
// module id = 174
// module chunks = 0